import React from 'react';

import {FullscreenText} from '../views/FullscreenText/FullscreenText.view';
import {withHeader} from '../hocs/withHeader';

export const PostMeeting: React.FC = withHeader(
    () => <FullscreenText>You left the meeting</FullscreenText>,
    'post-meeting',
);
